import { render, staticRenderFns } from "./SpreadSheet.vue?vue&type=template&id=bdb8fca4&scoped=true"
import script from "./SpreadSheet.vue?vue&type=script&lang=ts"
export * from "./SpreadSheet.vue?vue&type=script&lang=ts"
import style0 from "./SpreadSheet.scss?vue&type=style&index=0&id=bdb8fca4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb8fca4",
  null
  
)

export default component.exports